/* eslint-disable */
// Make sure webpack knows where to lazy-load chunks.
// This needs to loaded as the FIRST import.

if (typeof window !== 'undefined') {
  __webpack_public_path__ = window.resourceBasePath || '/'; // NOSONAR
} else {
  __webpack_public_path__ = process.argv[6] || '/'; // NOSONAR
}
/* eslint-enable */
